import {useState, useEffect} from 'react';
import {Form, Formik} from 'formik';
import Header from '../../../components/header';

import * as Yup from 'yup';

import UseGetProvince from '../../../utilities/hooks/province/useGetProvince';
import FormikSelect from '../../../components/formikFileds/select';
import {
  CitiesToOption,
  ProvincesToOption,
} from '../../../utilities/helper/provincesToOption';
import LocationMap from '../../../components/locationMap';
import CustomButton from '../../../components/customButton';
import {useNavigate} from 'react-router-dom';
import {useLab} from '../../../context/labContext';
import DropdownBadges from '../../../components/dropdown';
import {times_hours, work_times} from '../../post/utility/__data';
import useSetCityAndState from './hooks/useSetCityAndState';
import useScrollToTop from '../../../utilities/hooks/scrollToTop/useScrollToTop';

interface IAddLocation {
  state: string;
  city: string;
  location: ILocation;
  from_hour: string;
  to_hour: string;
  result_from_day: string;
  result_to_day: string;
}

const LabLocationForm = () => {
  const AddSchema = Yup.object().shape({
    state: Yup.string().required('استان اجباری می باشد'),
    city: Yup.string(),
    from_hour: Yup.string().required('ساعت فعالیت اجباری می باشد'),
    to_hour: Yup.string().required('ساعت فعالیت اجباری می باشد'),
    result_from_day: Yup.string().required('اجباری'),
    result_to_day: Yup.string().required('اجباری'),
  });

  const {lab, updateLocationInfo} = useLab();

  const {provinces} = UseGetProvince();
  const navigate = useNavigate();
  const [selectedStates, setSelectedStates] = useState<
    Array<Omit<IProvince, 'cities'>>
  >([]);

  const [selectedCities, setSelectedCities] = useState<Array<ICity>>([]);

  const initialValues: IAddLocation = {
    city: String(lab?.city?.id) || '',
    state: String(lab?.state?.id) || '',
    from_hour: lab?.from_hour || '',
    to_hour: lab?.to_hour || '',
    result_from_day: lab?.result_from_day || '',
    result_to_day: lab?.result_to_day || '',
    location: {
      lat: lab?.location?.lat || 35.7219,
      lng: lab?.location?.lng || 51.3347,
    },
  };
  useSetCityAndState({provinces, lab, setSelectedCities, setSelectedStates});

  useEffect(() => {
    if (!lab) {
      navigate('/lab/home');
    }
  }, [lab, navigate]);
  useScrollToTop();
  return (
    <>
      <Header title={'ایجاد آزمایشگاه'} />
      <div className="px-3 pb-4">
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={AddSchema}
          onSubmit={values => {
            updateLocationInfo({
              city: {id: Number(values.city)},
              location: values.location,
              state: {id: Number(values.state)},
              from_hour: values.from_hour,
              result_from_day: values?.result_from_day,
              result_to_day: values?.result_to_day,
              to_hour: values?.to_hour,
              activity_state: selectedStates,
              activity_city: selectedCities,
            });
            navigate('/lab/edit/owner');
          }}
        >
          {({setFieldValue, values}) => {
            return (
              <Form noValidate>
                <div className="mt-3">
                  <div className="mt-4">
                    <span className="fw-500">
                      محدوده آزمایشگاه <span className="color-red-3">*</span>
                    </span>
                  </div>
                  <div className="mt-4">
                    <FormikSelect
                      name="state"
                      label="استان"
                      Options={ProvincesToOption(provinces || [])}
                      required
                    />
                  </div>
                  <div className="mt-4">
                    <FormikSelect
                      name="city"
                      label="شهر"
                      Options={CitiesToOption(
                        provinces?.find(x => x.id === Number(values.state))
                          ?.cities || [],
                      )}
                      disabled={!values.state}
                    />
                  </div>
                  <div className="mt-4">
                    <span className="fw-500"> نقشه </span>
                  </div>
                  <div className="mt-3">
                    <div dir="ltr">
                      <LocationMap
                        center={values.location}
                        selectLocation={location =>
                          setFieldValue('location', location)
                        }
                      />
                    </div>
                  </div>
                  <div className="mt-5">
                    <span className="fw-500">
                      محدوده فعالیت
                      <small className="color-gray-3"> (اختیاری)</small>
                    </span>
                  </div>
                  <div className="mt-3">
                    <DropdownBadges
                      selectedAttributes={selectedStates}
                      setSelectedAttributes={setSelectedStates}
                      title="استان"
                      optionTitle="name"
                      options={provinces || []}
                    />
                  </div>
                  <div className="mt-3">
                    <DropdownBadges
                      selectedAttributes={selectedCities}
                      setSelectedAttributes={setSelectedCities}
                      title="شهرستان"
                      optionTitle="name"
                      options={
                        provinces
                          ?.filter((x: Omit<IProvince, 'cities'>) =>
                            selectedStates.includes(x),
                          )
                          ?.map(x => x.cities)
                          .flat() || []
                      }
                    />
                  </div>
                  <div className="mt-5">
                    <span className="fw-500"> ساعت کار آزمایشگاه</span>
                  </div>
                  <div className="mt-3">
                    <FormikSelect
                      name="from_hour"
                      label="از ساعت"
                      Options={times_hours}
                      required
                    />
                  </div>
                  <div className="mt-3">
                    <FormikSelect
                      name="to_hour"
                      label="تا ساعت"
                      Options={times_hours}
                      required
                    />
                  </div>
                  <div className="mt-3">
                    <span className="fw-500"> زمان ارائه نتیجه </span>
                  </div>
                  <div className="mt-3">
                    <div className="d-flex">
                      <FormikSelect
                        name="result_from_day"
                        label="از"
                        Options={work_times}
                        required
                      />
                      <span className="px-3 color-gray-1 pt-3">تا</span>
                      <FormikSelect
                        name="result_to_day"
                        label="تا "
                        Options={work_times}
                        required
                      />
                      <span className="px-3 color-gray-1  pt-3">روزکاری</span>
                    </div>
                  </div>
                  <div>
                    <small></small>
                  </div>
                </div>
                <div className="mt-4">
                  <CustomButton type="submit" title="ادامه" isLoading={false} />
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </>
  );
};

export default LabLocationForm;
